import * as React from 'react';

export const LazyProductSuccessCard = React.lazy(() => import('../../../../../../../../TextIndex/ProductSuccessCardContent'));
